export const getTeacherRoleState = (state: any) => state.teacherRole;
